import { Component, OnInit } from "@angular/core";
import { AtendimentoService } from "src/app/services/actions/atendimento.service";
import { ServerRoutes } from "src/app/ServerRoutes";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import jwt_decode from "jwt-decode";
import _ from 'lodash'

@Component({
	selector: "app-atendimento",
	templateUrl: "./atendimento.component.html",
	styleUrls: ["./atendimento.component.scss"],
})
export class AtendimentoComponent implements OnInit {
	atendimentos = [];
	atendimentosCancelados = [];
	paginaAtual = 1;
	statusFiltrado = [];
	status = "todos";
	atendimentoSelecionado = { id: "", comentarioAtendimento: "" };
	atendimentoAtivo = false;
	atendimentoPassou = false;
	hasAtendimento = false

	constructor(
		private atendimentoService: AtendimentoService,
		private routes: ServerRoutes,
		private toastr: ToastrService
	) {}

	ngOnInit() {
		moment.locale('pt-br')
		this.getAtendimentos();
	}

	addPagina(number) {
		if (this.paginaAtual <= 0 && number < 0) {
			return;
		}
		this.paginaAtual += number;
		if (!this.atendimentos[this.paginaAtual]) {
			this.getAtendimentos();
		}
	}

	getAtendimentos() {
		this.atendimentoService
			.getAtendimentosWithoutBloqued((this.paginaAtual - 1) * 10, 10, this.status)
			.subscribe(
				(res) => {
					const atendimentoFiltrados = _.filter(res["atendimentos"], (o) => { return o.status !== 'Bloqueado' })
					this.hasAtendimento = !_.isEmpty(atendimentoFiltrados)
					for (const atendimento of atendimentoFiltrados) {
						for (const usuario of res["usuarios"]) {
							if (parseInt(atendimento.userId) === parseInt(usuario.id)) {
								if (!usuario.image) {
									usuario.image = false
								} else if (usuario.image && !usuario.image.includes(this.routes.server)) {
									usuario.image = this.routes.server + "/client/photos/perfil/cliente/" + usuario.image
								}
								atendimento.usuario = usuario
							}
						}
						this.atendimentoAtivo = this.mostrarAtendimento(atendimento)
						this.atendimentoPassou = this.passouAtendimento(atendimento)
						const startMeet = this.verifyJwtStartMeet(atendimento)
						atendimento.date = moment(new Date(atendimento.date))
						atendimento.startMeet = startMeet
					}

					this.atendimentos[this.paginaAtual - 1] = res["atendimentos"];
				},
				(err) => {
					console.log(err);
				}
			);
	}

	filtrarAtendimentos(status) {
		this.atendimentos = [];
		this.paginaAtual = 1;
		this.status = status;
		this.getAtendimentos();
	}

	recusarAtendimento(atendimento) {
		this.atendimentoService.recusarAtendimento(atendimento.id).subscribe(
			(res) => {
				this.toastr.success(
					"Atendimento recusado com sucesso",
					"Sucesso"
				);
				this.getAtendimentos();
			},
			(err) => {
				this.toastr.warning(
					"Não foi possível recusar este atendimento",
					"Atenção"
				);
			}
		);
	}

	selecionarAtendimento(atendimento) {
		this.atendimentoSelecionado = atendimento;
	}

	comentarAtendimento() {
		this.atendimentoService
			.comentarAtendimento(
				this.atendimentoSelecionado.id,
				this.atendimentoSelecionado.comentarioAtendimento
			)
			.subscribe(
				(res) => {
					this.toastr.success("Comentário atualizado com sucesso");
				},
				(err) => {
					this.toastr.error("Tente novamente mais tarde", "Erro");
				}
			);
	}

	mostrarAtendimento(atendimento) {
		const finalHour = moment(atendimento.date).add(1, 'hour')
		return moment() >= moment(atendimento.date) && moment() <= finalHour
	}

	passouAtendimento (atendimento) {
		const finalHour = moment(atendimento.date).add(1, 'hour')
		return moment() >= finalHour
	}

	verifyJwtStartMeet (atendimento) {
		if (atendimento.sessionId) {
			try {
				jwt_decode(atendimento.sessionId);
				return true
			} catch (error) {
				return false
			}
		}
	}

	capitalizeFirstLetter (string) {
		return string.charAt(0).toUpperCase() + string.slice(1)
	}
}
